import antdData from 'antd/lib/locale/ja_JP'
import jaMessages from '../locales/ja-JP'

const jaLang = {
  messages: {
    ...jaMessages
  },
  antd: antdData,
  locale: 'ja-JP'
}
export default jaLang
